import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudRowsServiceBase, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { AMMUNITION_STOCK_EVENT_TYPE, AmmunitionStockEvent } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class AmmunitionStockEventRowsServiceBase<G> extends CrudRowsServiceBase<AmmunitionStockEvent, number, G> {

  servicePath: string = '/ammunitionstockevent';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, AMMUNITION_STOCK_EVENT_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification): Observable<HateoasMultipleResponseObject<AmmunitionStockEvent>> {
    var params = appendSerialisedHttpParams(filters);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<AmmunitionStockEvent>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



